export enum PropCheckoutType {

    Popup = "popup",
    MultiStep = "multistep",
}
